import { render, staticRenderFns } from "./Hopital.vue?vue&type=template&id=77f91137&"
import script from "./Hopital.vue?vue&type=script&lang=js&"
export * from "./Hopital.vue?vue&type=script&lang=js&"
import style0 from "./Hopital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports